import { cn } from "../../utils/cn";

const Brand = ({ muted = false }: { muted?: boolean }) => {
    return (
        <a
            className={cn(
                "font-deco transition-all hover:opacity-80 bg-bg rounded-full py-1 px-4 md:p-0 md:bg-transparent",
                muted && "opacity-50"
            )}
            href="/#heim"
        >
            <p className="text-lg flex">
                K<span className="hidden lg:block">arolina&nbsp;</span>Z
                <span className="hidden lg:block">ielińska</span>
            </p>
        </a>
    );
};

export default Brand;
